<template>
    <button class="normalbtn" :class="[theme, disabled ? 'disabled' : '']" @click='click'>
        <span v-show='loading'>
            
            <i class="i1"></i>
            <i class="i2"></i>
            <i class="i3"></i>
            <i class="i4"></i>
            <i class="i5"></i>
            <i class="i6"></i>
            <i class="i7"></i>
            <i class="i8"></i>
        </span>
        <span v-show='!loading'><slot></slot></span>
    </button>
</template>

<script>
export default {
    name: "normalbutton",
    props: {
        theme: {
            type: String,
            default: 'blue'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: ()=>({
        loading: false
    }),
    methods: {
        finish () {
            this.loading = false
        },
        load () {
            this.loading = true
        },
        click () {
            if (this.disabled) return
            if (this.loading) {
                this.$market && this.$market.alert({content: '操作不要太频繁'})
                return
            }
            this.loading = true
            this.$emit('click',this.finish,this.load)
        }
    },
    mounted () {
        
    }
};
</script>

<style scoped>
.normalbtn {
    white-space: nowrap;
    color: white;
    /* font-size:inherit; */
    font-family: 'microsoft yahei';
    border: 0;
    border-radius: 3px;
    outline: 0;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
}
.normalbtn.disabled {
    opacity: 0.6 !important;
    cursor: not-allowed;
}
.normalbtn:hover {
    opacity: 0.75;
}
.normalbtn.blue {
    background: rgb(6, 96, 172);
}
.normalbtn.red {
    background: rgb(212, 2, 1);
}
.normalbtn i {
    display: inline-block;
    width: 6px;
    height: 2px;
    background: white;
    border-radius: 1px;
}
@keyframes flash {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
.normalbtn .i1 {
    animation: flash .8s ease infinite;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -1px;
    margin-left: 3px;

}
.normalbtn .i2 {
    animation: flash .8s ease infinite .1s;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -6px;
    margin-left: 1px;
    transform: rotate(-45deg);
}
.normalbtn .i3 {
    animation: flash .8s ease infinite .2s;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -7px;
    margin-left: -4px;
    transform: rotate(90deg);
}
.normalbtn .i4 {
    animation: flash .8s ease infinite .3s;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -6px;
    margin-left: -9px;
    transform: rotate(45deg);
}
.normalbtn .i5 {
    animation: flash .8s ease infinite .4s;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -1px;
    margin-left: -11px;
}
.normalbtn .i6 {
    animation: flash .8s ease infinite .5s;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: 5px;
    margin-left: -9px;
    transform: rotate(-45deg);
}
.normalbtn .i7 {
    animation: flash .8s ease infinite .6s;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: 7px;
    margin-left: -4px;
    transform: rotate(90deg);
}
.normalbtn .i8 {
    animation: flash .8s ease infinite .7s;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: 5px;
    margin-left: 2px;
    transform: rotate(45deg);
}
</style>
